(() => {

  'use strict';

  const enabled = document.querySelector('[data-itc-routes]')?.dataset.draftPreview === 'true';

  if (!enabled) return;

  const lifetime = 7 * 24 * 60 * 60 * 1000;

  let connection;

  function database() {

    if (!connection) connection = new Promise((resolve, reject) => {

      const request = indexedDB.open('itc-unpublished-cart-v1', 1);

      request.onupgradeneeded = () => request.result.createObjectStore('items', {keyPath: 'key'});

      request.onsuccess = () => resolve(request.result);

      request.onerror = () => reject(request.error);

      request.onblocked = () => reject(new Error('Site storage is blocked'));

    });

    return connection;

  }

  async function operation(mode, run) {

    const db = await database();

    return new Promise((resolve, reject) => {

      const transaction = db.transaction('items', mode);

      const request = run(transaction.objectStore('items'));

      transaction.oncomplete = () => resolve(request.result);

      transaction.onerror = transaction.onabort = () => reject(transaction.error || new Error('Unable to save preview'));

    });

  }

  const put = item => operation('readwrite', store => store.put(item));

  const remove = key => operation('readwrite', store => store.delete(key));

  async function list() {

    const items = await operation('readonly', store => store.getAll());

    const stale = items.filter(item => Date.now() - item.created > lifetime);

    await Promise.all(stale.map(item => remove(item.key)));

    return items.filter(item => Date.now() - item.created <= lifetime).sort((a,b) => a.created - b.created);

  }

  async function save({selected, properties, photos}) {

    await list();

    await put({key: crypto.randomUUID(), created: Date.now(), quantity: 1, selected, properties, photos});

  }

  window.ITCDraftCart = {save, list, put, remove};

  const node = (tag, text, className) => {

    const element = document.createElement(tag);

    if (text != null) element.textContent = text;

    if (className) element.className = className;

    return element;

  };

  const money = value => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(value / 100);

  const safeImage = value => {

    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : ''; } catch { return ''; }

  };

  const urls = [];

  function localImage(blob) {

    const url = URL.createObjectURL(blob); urls.push(url); return url;

  }

  async function render() {

    const mount = document.querySelector('[data-itc-preview-cart]');

    const status = document.querySelector('[data-itc-preview-status]');

    try {

      const items = await list();

      document.querySelectorAll('.itc-cart-link').forEach(link => {

        const original = link.dataset.originalLabel || link.textContent.trim(); link.dataset.originalLabel = original;

        const count = items.reduce((sum,item) => sum + item.quantity, 0);

        const badge=link.querySelector('[data-itc-cart-count]');if(badge)badge.textContent=String(Number(badge.dataset.realCount||badge.textContent||0)+count);else link.textContent=count?original+' · Preview ('+count+')':original;

        link.setAttribute('aria-label', 'Your cart, ' + (Number(link.querySelector('[data-itc-cart-count]')?.textContent || 0)) + ' items');

      });

      if (!mount) return;

      urls.splice(0).forEach(url => URL.revokeObjectURL(url));

      mount.replaceChildren(); mount.hidden = !items.length;

      const empty = document.querySelector('[data-itc-empty-cart]');

      if (empty) empty.hidden = !!items.length;

      if (!items.length) return;

      mount.append(node('p', 'Draft cart preview — these products are not on sale yet. No order or payment will be created. Photos stay in this browser, are removed with the item, and expire from this preview after seven days.', 'itc-draft-notice'));

      const layout = node('div', null, 'itc-cart__layout');

      const rows = node('div'); const summary = node('aside', null, 'itc-cart__summary');

      let total = 0;

      for (const item of items) {

        total += item.selected.price * item.quantity;

        const row = node('article', null, 'itc-cart__item');

        const visual = node('div'); const detail = node('div');

        const properties = item.properties;

        const imageUrl = safeImage(properties['_Artwork preview']);

        if (imageUrl) {

          const image = node('img', null, 'itc-preview-art'); image.src = imageUrl; image.alt = properties.World || properties['Artwork style'] || 'Selected artwork style';

          image.style.setProperty('--preview-frame', {'White frame':'#f4f2ed','Black frame':'#292929','Antique Gold':'#ba914b'}[item.selected.frame] || 'transparent'); visual.append(image);

        } else if (properties['_Sky preview']) {

          const sky = node('div', null, 'itc-preview-sky');

          const image = node('img'); image.src = localImage(new Blob([properties['_Sky preview']], {type:'image/svg+xml'})); image.alt = 'Your selected sky'; sky.append(image);

          for (const name of ['Date','Your words','Display location']) sky.append(node('small', properties[name]));

          sky.style.borderColor = {'White frame':'#f4f2ed','Black frame':'#292929','Antique Gold':'#ba914b'}[item.selected.frame] || 'transparent'; visual.append(sky);

        }

        for (const photo of item.photos || []) {

          const reference = node('span', null, 'itc-preview-reference');

          const image = node('img'); image.src = localImage(photo); image.alt = 'Reference photograph: ' + photo.name;

          reference.append(image, node('small', photo.name)); visual.append(reference);

        }

        detail.append(node('h2', properties.World ? 'Grand Theft Artwork · ' + properties.World : properties['Artwork style'] || (properties['Football style'] ? 'Football is Life · '+properties['Football style'] : 'Personalised star map')));

        detail.append(node('p', [item.selected.format,item.selected.size,item.selected.frame].join(' / ')));

        const details = node('dl');

        for (const [name,value] of Object.entries(properties)) {

          if (name.startsWith('_') || ['Latitude','Longitude','Timezone','Location source','Calculated location'].includes(name) || value == null || value === '') continue;

          const entry = node('div'); entry.append(node('dt',name),node('dd',value)); details.append(entry);

        }

        detail.append(details);

        if (item.photos?.length) detail.append(node('p', 'Artwork style and supplied reference shown. Your finished portrait is created after ordering.', 'itc-preview-reference'));

        const quantity = node('div', null, 'itc-cart__quantity');

        const label = node('label','Quantity'); const input = node('input');

        input.type = 'number'; input.min = '1'; input.max = '99'; input.value = item.quantity; input.id = 'preview-' + item.key; label.htmlFor = input.id;

        const deleteButton = node('button','Remove', 'button button--outline'); deleteButton.type = 'button'; deleteButton.setAttribute('aria-label','Remove ' + detail.querySelector('h2').textContent);

        const price = node('strong', money(item.selected.price * item.quantity)); price.dataset.previewLinePrice = '';

        input.addEventListener('change', async () => {

          const value = Number(input.value);

          if (!Number.isInteger(value) || value < 1 || value > 99) { input.value = item.quantity; return; }

          input.disabled = true;

          try { await put({...item, quantity:value}); await render(); } catch { input.disabled = false; input.value = item.quantity; status.textContent = 'The quantity could not be saved. Please try again.'; }

        });

        deleteButton.addEventListener('click', async () => {

          deleteButton.disabled = true;

          try { await remove(item.key); await render(); status.textContent = 'Artwork removed from the draft preview.'; } catch { deleteButton.disabled = false; status.textContent = 'The item could not be removed. Please try again.'; }

        });

        quantity.append(label,input,deleteButton); detail.append(quantity,price); row.append(visual,detail); rows.append(row);

      }

      const totalLine = node('div',null,'itc-cart__total'); totalLine.append(node('span','Preview subtotal'),node('strong',money(total)));

      summary.append(totalLine,node('p','Free UK delivery.'),node('p','Check your size, finish and personalisation details here. Checkout for these draft items will become available when the products are launched.'));

      const continueLink = node('a','Continue exploring','button button--gold'); continueLink.href = '/pages/explore'; summary.append(continueLink);

      layout.append(rows,summary); mount.append(layout);

    } catch { if (status) status.textContent = 'The draft preview could not be loaded. Please allow site storage and reload.'; }

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();

  window.addEventListener('pageshow', event => { if (event.persisted) render(); });

})();



(() => {

  'use strict';

  const catalogue = JSON.parse(document.querySelector('[data-itc-catalogue]')?.textContent || '{}');

  const root = document.querySelector('[data-itc-routes]')?.dataset.root || '/';

  const money = cents => new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'}).format(cents / 100);

  const finish = value => ({print: 'Print only', none: 'Print only', 'No frame': 'Print only', black: 'Black frame', white: 'White frame', gold: 'Antique Gold', 'Gold frame': 'Antique Gold'}[value] || value);

  const variant = (range, size, frame, format = 'Single print', style = '') => {

    const choices = (catalogue[range] || []).filter(v => !v.legacy && v.size === size && v.frame === finish(frame) && v.format === format);

    return (style && choices.find(v => v.style === style)) || choices.find(v => !v.style);

  };

  const showPrice = (scope, selected) => {

    scope.querySelectorAll('[data-itc-price]').forEach(el => { el.textContent = selected ? money(selected.price) : 'Please choose a size and finish'; });

  };

  const proof = scope => scope.matches('[data-portrait-personaliser]') && scope.querySelector('[data-itc-proof]')?.checked ? 'Requested — allow an extra day; print after approval' : window.ITCProof.notRequested;

  const prepare = scope => {

    if(scope.matches('[data-star-map-form],[data-football-form],[data-gta-form]')){scope.querySelectorAll('[data-itc-proof]').forEach(input=>input.closest('label')?.remove());scope.querySelectorAll('[data-itc-proof-summary]').forEach(el=>el.remove());return null;}

    const selected = scope.querySelector('[data-itc-proof]');

    scope.querySelectorAll('[data-itc-proof-summary]').forEach(el => { window.ITCProof.render(el,Boolean(selected?.checked)); });

    return selected;

  };

  const setStatus = (el, message) => { if (el) el.textContent = message; };

  async function add({selected, properties, photos = [], button, status}) {

    if (button.dataset.sending === 'true' || button.dataset.added === 'true') return;

    properties={...properties,'_Selected frame':selected?.frame||'Print only','_Selected size':selected?.size||''};

    const artwork = button.closest?.('[data-portrait-personaliser]')?.querySelector('.portrait-personaliser__frame-artwork');

    if (artwork) properties = {...properties, '_Artwork preview': artwork.currentSrc || artwork.src};

    const isPortrait = ['portraits-for-him','portraits-for-her','pet-portraits','grand-theft-artwork'].includes(selected?.range) || Boolean(properties['Artwork style'] || properties.World);

    if (isPortrait && !photos.length) { setStatus(status, 'Add a clear photograph before continuing.'); return; }

    if (properties.World && (!properties.Accessory || !properties['_Style key'])) { setStatus(status, 'Choose your world and signature accessory before continuing.'); return; }

    const draft = selected?.preview && document.querySelector('[data-itc-routes]')?.dataset.draftPreview === 'true';

    if (!selected?.available && !draft) { setStatus(status, 'This artwork is not currently available to purchase.'); return; }

    if (photos.some(file => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 20_000_000 || file.size === 0)) {

      setStatus(status, 'Choose JPG, PNG or WebP photographs up to 20MB each.'); return;

    }

    if (draft) {

      button.dataset.sending = 'true'; button.disabled = true;

      setStatus(status, 'Saving your artwork to the draft cart preview…');

      try {

        await window.ITCDraftCart.save({selected, properties, photos});

        button.dataset.added = 'true';

        window.location.assign(root + 'cart');

      } catch (error) {

        setStatus(status, 'Your browser could not save the draft preview. Please allow site storage and try again.');

        button.disabled = false;

      } finally { button.dataset.sending = 'false'; }

      return;

    }

    if (!properties['Artwork style']) delete properties.Proof;

    const payload = new FormData();

    payload.set('id', selected.id); payload.set('quantity', '1');

    for (const [name, value] of Object.entries(properties)) if (value !== '' && value != null && name !== '_Sky preview') payload.set(`properties[${name}]`, String(value));

    photos.forEach((file, i) => payload.set(`properties[${i ? 'Supporting photo ' + i : 'Primary photo'}]`, file, file.name));

    button.dataset.sending = 'true'; button.disabled = true;

    setStatus(status, photos.length ? 'Uploading your photographs and adding your artwork…' : 'Adding your artwork…');

    try {

      const configuredPreview = await window.ITCConfiguredPreview?.createFile(properties, selected);

      if(configuredPreview)payload.set('properties[_Configured preview]',configuredPreview,configuredPreview.name);

      const response = await fetch(root + 'cart/add.js', {method: 'POST', body: payload, headers: {Accept: 'application/json'}});

      const item = await response.json();

      if (!response.ok) throw new Error(typeof item.description === 'string' ? item.description : 'Unable to add this artwork. Please try again.');

      button.dataset.added = 'true';

      // Confirm the upload response contains stored file links, rather than local filenames.

      if (photos.length && photos.some((_, i) => !String(item.properties?.[i ? 'Supporting photo ' + i : 'Primary photo'] || '').includes('/uploads/'))) {

        setStatus(status, 'Your artwork was added, but the photo upload needs checking. Please review your cart before checkout.');

      }

      window.location.assign(root + 'cart');

    } catch (error) {

      setStatus(status, error.message || 'The connection was interrupted. Check your cart before trying again.');

      button.disabled = false;

    } finally { button.dataset.sending = 'false'; }

  }

  window.ITCCommerce = {variant, money, showPrice, proof, prepare, add};



  function init() {

    document.querySelectorAll('[data-gta-form]').forEach(form => {

      if (form.dataset.commerceReady) return; form.dataset.commerceReady = 'true';

      const status = form.querySelector('[data-itc-status]'); const button = form.querySelector('[data-itc-add]');

      const selectedVariant = () => variant('grand-theft-artwork', form.elements.size.value, form.elements.frame.value, form.elements.format.value === 'triptych' ? 'Triple set' : 'Single print');

      const update = () => { showPrice(form, selectedVariant()); prepare(form); };

      form.addEventListener('change', update); update();

      button.addEventListener('click', () => {

        const photo = form.elements.photo; const accessory = form.elements.accessory.value;

        if (!photo.files.length) { photo.closest('details').open = true; setStatus(status, 'Add their photograph before continuing.'); photo.focus(); return; }

        if (!accessory) { form.querySelector('[name="accessory"]').closest('details').open = true; setStatus(status, 'Choose one signature accessory before continuing.'); return; }

        if (!form.reportValidity()) return;

        const config = JSON.parse(form.closest('[data-gta-root]').querySelector('[data-gta-config]').textContent);

        const world = config.worlds.find(w => w.key === form.elements.world.value);

        const chosen = selectedVariant();

        add({selected: chosen, button, status, photos: [...photo.files], properties: {

          World: world.name, Accessory: config.accessories.find(a => a.key === accessory)?.name || accessory,

          Notes: form.elements.notes.value.trim(), Proof: proof(form),

          '_Style key': world.key, '_Design URL': location.pathname + location.search,

          '_Artwork preview': chosen.format === 'Triple set' ? world.wide : world.single

        }});

      });

    });

    document.querySelectorAll('[data-star-map-form]').forEach(form => {

      if (form.dataset.commerceReady) return; form.dataset.commerceReady = 'true';

      const section = form.closest('[data-star-map-preview]'); const button = form.querySelector('[data-itc-add]'); const status = form.querySelector('[data-itc-status]');

      const selectedVariant = () => variant('star-maps', form.elements.print_size.value.slice(0, 2), form.elements.frame_upgrade.value, 'Single print', form.elements.artwork_tone.value);

      const update = () => showPrice(form.closest('[data-star-map-modal]') || form, selectedVariant()); form.addEventListener('change', update); update();

      button.addEventListener('click', async () => {

        if (button.dataset.preparing) return;

        if (!form.reportValidity()) return;

        button.dataset.preparing = 'true';

        try {

          if (!section.itcPrepareStarMap || !await section.itcPrepareStarMap()) { setStatus(status, 'Please choose a recognised city and reveal your sky before continuing.'); return; }

          const fields = {artwork_tone: 'Artwork finish', location_detail: 'Place', city: 'City', country: 'Country', date: 'Date', time: 'Local time', personal_message: 'Your words', display_location: 'Display location', resolved_location: 'Calculated location', latitude: 'Latitude', longitude: 'Longitude', timezone: 'Timezone', location_resolution: 'Location source'};

          const properties = {Proof: window.ITCProof.notRequested, '_Design URL': location.pathname, '_Sky catalogue': 'ITC star catalogue v1', 'Bespoke silhouette': form.elements.include_silhouette.checked ? 'Yes' : 'No'};

          for (const [key, label] of Object.entries(fields)) properties[label] = form.elements[key].value;

          if (form.elements.include_silhouette.checked) properties['Silhouette instructions'] = form.elements.silhouette_brief.value.trim();

          const sky = section.querySelector('[data-star-map-svg]');

          if (sky) properties['_Sky preview'] = new XMLSerializer().serializeToString(sky);

          const brief = {version:1,skyCatalogue:'ITC star catalogue v1',date:properties.Date,time:properties['Local time'],latitude:properties.Latitude,longitude:properties.Longitude,timezone:properties.Timezone,tone:properties['Artwork finish'],words:properties['Your words'],place:properties['Display location'],size:selectedVariant().size,silhouette:form.elements.include_silhouette.checked,silhouetteBrief:form.elements.include_silhouette.checked?form.elements.silhouette_brief.value.trim():''};

          properties['_Production brief'] = JSON.stringify(brief);

          for (const name of ['Latitude','Longitude','Timezone','Location source','Calculated location']) { properties['_' + name] = properties[name]; delete properties[name]; }

          await add({selected: selectedVariant(), properties, button, status});

        } finally { delete button.dataset.preparing; }

      });

    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', init);

})();







